<template>
  <ul class="menu-nav">
    <router-link
      to="/oms/dashboard"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon flaticon2-architecture-and-city"></i>
          <span class="menu-text">总览</span>
        </a>
      </li>
    </router-link>

    <!--    <router-link-->
    <!--      to="/oms/builder"-->
    <!--      v-slot="{ href, navigate, isActive, isExactActive }"-->
    <!--    >-->
    <!--      <li-->
    <!--        aria-haspopup="true"-->
    <!--        data-menu-toggle="hover"-->
    <!--        class="menu-item"-->
    <!--        :class="[-->
    <!--          isActive && 'menu-item-active',-->
    <!--          isExactActive && 'menu-item-active'-->
    <!--        ]"-->
    <!--      >-->
    <!--        <a :href="href" class="menu-link" @click="navigate">-->
    <!--          <i class="menu-icon flaticon2-expand"></i>-->
    <!--          <span class="menu-text">Layout Builder</span>-->
    <!--        </a>-->
    <!--      </li>-->
    <!--    </router-link>-->

    <li class="menu-section">
      <h4 class="menu-text">产品</h4>
      <i class="menu-icon flaticon-more-v2"></i>
    </li>

    <router-link
      to="/oms/secret/order"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon flaticon2-expand"></i>
          <span class="menu-text">短效代理</span>
        </a>
      </li>
    </router-link>

    <!--    <router-link-->
    <!--      to="/oms/tunnel/order"-->
    <!--      v-slot="{ href, navigate, isActive, isExactActive }"-->
    <!--    >-->
    <!--      <li-->
    <!--        aria-haspopup="true"-->
    <!--        data-menu-toggle="hover"-->
    <!--        class="menu-item"-->
    <!--        :class="[-->
    <!--          isActive && 'menu-item-active',-->
    <!--          isExactActive && 'menu-item-active'-->
    <!--        ]"-->
    <!--      >-->
    <!--        <a :href="href" class="menu-link" @click="navigate">-->
    <!--          <i class="menu-icon flaticon-web"></i>-->
    <!--          <span class="menu-text">隧道代理</span>-->
    <!--        </a>-->
    <!--      </li>-->
    <!--    </router-link>-->

    <li class="menu-section">
      <h4 class="menu-text">功能</h4>
      <i class="menu-icon flaticon-more-v2"></i>
    </li>

    <router-link
      to="/oms/white/list"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon flaticon-web"></i>
          <span class="menu-text">白名单</span>
        </a>
      </li>
    </router-link>

    <router-link
      to="/oms/expend"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon flaticon-web"></i>
          <span class="menu-text">收支明细</span>
        </a>
      </li>
    </router-link>

    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{ 'menu-item-open': hasActiveChildren('/vue-bootstrap') }"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="menu-icon flaticon2-digital-marketing"></i>
        <span class="menu-text">发票管理</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu">
        <span class="menu-arrow"></span>
        <ul class="menu-subnav">
          <li aria-haspopup="true" class="menu-item menu-item-parent">
            <span class="menu-link">
              <span class="menu-text">发票管理</span>
            </span>
          </li>
          <router-link
            to="/oms/invoice/request"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-icon flaticon-web"></i>
                <span class="menu-text">发票申请</span>
              </a>
            </li>
          </router-link>
          <li aria-haspopup="true" class="menu-item menu-item-parent">
            <span class="menu-link">
              <span class="menu-text">发票管理</span>
            </span>
          </li>
          <router-link
            to="/oms/invoice/title"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-icon flaticon-web"></i>
                <span class="menu-text">发票抬头</span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li>

    <!--    <li-->
    <!--      aria-haspopup="true"-->
    <!--      data-menu-toggle="hover"-->
    <!--      class="menu-item menu-item-submenu"-->
    <!--      v-bind:class="{ 'menu-item-open': hasActiveChildren('vuetify') }"-->
    <!--    >-->
    <!--      <a href="#" class="menu-link menu-toggle">-->
    <!--        <i class="menu-icon flaticon-web"></i>-->
    <!--        <span class="menu-text">隧道代理</span>-->
    <!--        <i class="menu-arrow"></i>-->
    <!--      </a>-->
    <!--      <div class="menu-submenu">-->
    <!--        <span class="menu-arrow"></span>-->
    <!--        <ul class="menu-subnav">-->
    <!--          <li aria-haspopup="true" class="menu-item menu-item-parent">-->
    <!--            <span class="menu-link">-->
    <!--              <span class="menu-text">隧道代理</span>-->
    <!--            </span>-->
    <!--          </li>-->

    <!--          <router-link-->
    <!--            to="/oms/tunnel/order"-->
    <!--            v-slot="{ href, navigate, isActive, isExactActive }"-->
    <!--          >-->
    <!--            <li-->
    <!--              aria-haspopup="true"-->
    <!--              data-menu-toggle="hover"-->
    <!--              class="menu-item"-->
    <!--              :class="[-->
    <!--                isActive && 'menu-item-active',-->
    <!--                isExactActive && 'menu-item-active'-->
    <!--              ]"-->
    <!--            >-->
    <!--              <a :href="href" class="menu-link" @click="navigate">-->
    <!--                <i class="menu-bullet menu-bullet-dot">-->
    <!--                  <span></span>-->
    <!--                </i>-->
    <!--                <span class="menu-text">隧道代理订单</span>-->
    <!--              </a>-->
    <!--            </li>-->
    <!--          </router-link>-->
    <!--        </ul>-->
    <!--      </div>-->
    <!--    </li>-->
  </ul>
</template>

<script>
export default {
  name: "KTMenu",
  methods: {
    hasActiveChildren(match) {
      return this.$route["path"].indexOf(match) !== -1;
    },
  },
};
</script>
